var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDatabase = function SvgDatabase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.165 15.001c0 1.841-2.984 3.334-6.666 3.334S3.832 16.842 3.832 15v-3.355c.419.514 1.012.941 1.673 1.271 1.31.656 3.077 1.043 4.994 1.043s3.683-.388 4.993-1.043c.66-.33 1.255-.757 1.673-1.27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.499 8.96c1.917 0 3.683-.388 4.993-1.043.66-.33 1.255-.757 1.673-1.27V10c0 .417-1.488 1.326-2.232 1.798-1.102.552-2.67.91-4.434.91s-3.332-.358-4.435-.91c-.982-.49-2.232-1.381-2.232-1.798V6.646c.419.514 1.012.941 1.673 1.271 1.31.655 3.077 1.043 4.994 1.043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.933 6.8c-1.102.55-2.67.91-4.434.91s-3.332-.36-4.435-.91c-.416-.164-1.337-.672-2.004-1.491a.84.84 0 0 1-.179-.687c.017-.091.039-.177.064-.235.577-1.548 3.292-2.719 6.554-2.719s5.976 1.171 6.553 2.719c.026.058.047.144.064.235a.84.84 0 0 1-.178.687c-.667.819-1.588 1.327-2.005 1.49"
  }))));
};
export default SvgDatabase;